import React from 'react'
import './overview.css'

const Labs = () => {
    return (
        <div>
            zenith is here with the overview
        </div>
    )
}

export default Labs